<template>
    <div class="app">
        <div class="title">
            <div class="dis">
                <div class="title_text">人员管理</div>
            </div>
        </div>

        <div class="head_box">
            <div class="ipt_list">
                <div class="box1">
                    <div class="dis">
                        <div class="first_title">姓名</div>
                        <el-input v-model="value1" placeholder="请输入" clearable></el-input>
                    </div>
                </div>
                <div class="box1">
                    <div class="dis">
                        <div class="other_title">手机号</div>
                        <el-input v-model="value2" placeholder="请输入" clearable></el-input>
                    </div>
                </div>
                <div class="box1">
                    <div class="dis">
                        <el-button class="search_btn dis_center" type="primary" @click="rold()">
                            <div class="dis_center">
                                <div>搜索</div>
                            </div>
                        </el-button>
                        <el-button class="Add_btn dis_center" type="primary" @click="add_btn(0)">
                            <div class="dis_center">
                                <img class="img11" src="../../assets/12.png" alt="" />
                                <div>新增</div>
                            </div>
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table_pad">
            <div class="table">
                <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe
                    @selection-change="handleSelectionChange" :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ textAlign: 'center' }">
                    <el-table-column type="index" label="序号" width="65">
                    </el-table-column>
                    <el-table-column prop="personName" label="姓名" min-width="10%">
                    </el-table-column>
                    <el-table-column prop="personPhone" label="手机号" min-width="10%">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" min-width="10%">
                    </el-table-column>
                    <el-table-column prop="address" label="操作" min-width="15%">
                        <template slot-scope="scope">
                            <div class="dis_center table_btn">
                                <div class="dis" @click="add_btn(1, scope.row)">
                                    <div>修改</div>
                                </div>
                                <div class="dis table_delete" @click="delete_btn(0, scope.row.id)">
                                    <div>删除</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page_box">
                <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                    :current-page.sync="pageNumber" :total="total">
                </el-pagination>
            </div>
        </div>

        <div class="shardow dis_center" v-if="show_shardow">
            <div class="show_box">
                <div class="show_title dis_center">
                    <div v-if="show_type == 0">新增人员</div>
                    <div v-else>修改人员</div>
                    <img src="../../assets/19.png" class="img19" alt="" @click="close" />
                </div>
                <div class="show_detail" style="height: 200rem;">
                    <div class="dis_center shardow_ipt_box">
                        <div class="shardow_title"><span style="color: red;">* </span>姓 名：</div>
                        <el-input class="shardow_ipt" v-model="form.personName" placeholder="请输入姓名"></el-input>
                    </div>
                    <div class="dis_center shardow_ipt_box">
                        <div class="shardow_title"><span style="color: red;">* </span>手机号：</div>
                        <el-input class="shardow_ipt" v-model="form.personPhone" placeholder="请输入手机号"></el-input>
                    </div>
                </div>
                <div class="shardow_btn dis_center">
                    <div class="shardow_btn1 dis_center" @click="close">取消</div>
                    <button class="shardow_btn2 dis_center" @click="save" :disabled="disabled_save">
                        确定
                    </button>
                </div>
            </div>
        </div>

        <div class="shardow dis_center" v-if="show_delete">
            <div class="show_box">
                <div class="show_title dis_between">
                    <div>删除确认</div>
                    <img src="../../assets/19.png" class="img19" alt="" @click="close" />
                </div>
                <div class="dis_center shardow_deleteInfo">
                    <img src="../../assets/20.png" class="img20" alt="" />
                    <div>确定要删除所选择的人员吗？</div>
                </div>
                <div class="shardow_btn dis_center">
                    <div class="shardow_btn1 dis_center" @click="close">取消</div>
                    <div class="shardow_btn2 dis_center" @click="remove">确定</div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import {
    img_url,
    api,
    editProjectPerson,
    getProjectPersonMePage,
    removeProjectPerson,
    getProjectPersonDetail
} from "../js/api";
import axios from "axios";
export default {
    data() {
        return {
            img_url: "",
            disabled_save: false,
            userInfo: {},
            info: {
                title: "",
                courseType: "",
                duration: "",
                videoUrl: "",
            },
            form: {
                personName: "",
                personPhone: ""
            },
            multipleSelection: [],
            chooseId: "",
            show_type: 0,
            show_shardow: false,
            show_delete: false,
            delete_type: 0,
            pageNumber: 1,
            pageSize: 10,
            total: 0,
            value1: "",
            value2: "",
            tableData: [],
            multipleSelection: [],
            options1: []
        };
    },
    created() {
        let that = this;
        that.img_url = img_url;
        that.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        that.ajaxload();
    },
    methods: {
        // 移除不需要的视频相关方法
        // jump(), selectVideo(), videoPreview(), isVideoFile() 方法已删除，因为项目人员管理不需要这些功能

        rold() {
            let that = this;
            that.pageNumber = 1;
            that.ajaxload();
        },
        ajaxload() {
            let that = this;
            let json = {
                pageReq: {
                    pageNumber: that.pageNumber,
                    pageSize: that.pageSize,
                },
                entityParam: {},
            };
            if (that.value1 || that.value2) {
                json.keyWords = {
                };
            }
            if (that.value1) {
                json.keyWords.personName = that.value1;
            }
            if (that.value2) {
                json.keyWords.personPhone = that.value2;
            }
            getProjectPersonMePage(json).then((res) => {
                if (res.code == 200) {
                    that.tableData = res.data.records || [];
                    that.total = Number(res.data.total);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 移除不需要的方法
        // get_list() 和 getCourseTypeName() 方法已删除，因为项目人员管理不需要这些功能
        save() {
            let that = this;
            that.disabled_save = true;
            let json = that.form;
            if (!json.personName || !json.personPhone) {
                this.$message({
                    message: "请完善人员信息，姓名和手机号为必填项",
                    type: "warning",
                    duration: 1000,
                });
                that.disabled_save = false;
                return;
            }
            editProjectPerson(json).then((res) => {
                that.disabled_save = false;
                if (res.code == 200) {
                    that.close();
                    this.$message({
                        message: "保存成功",
                        type: "success",
                    });
                    that.ajaxload();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        remove() {
            let that = this;
            let json = {};
            json.id = that.chooseId;
            removeProjectPerson({ params: json }).then((res) => {
                if (res.code == 200) {
                    that.close();
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                    that.ajaxload();
                } else {
                    this.$message.error(res.message);
                    that.close();
                    that.ajaxload();
                }
            });
        },
        delete_btn(e, w) {
            let that = this;
            if (e == 0) {
                that.chooseId = w;
            } else if (e == 1) {
                if (that.multipleSelection.length == 0) {
                    this.$message({
                        message: "请选择用户",
                        type: "warning",
                    });
                    return;
                }
            }
            that.delete_type = e;
            that.show_delete = true;
        },
        add_btn(e, w) {
            let that = this;
            if (e == 0) {
                that.form = {
                    personName: "",
                    personPhone: ""
                };
            } else {
                that.form = w;
            }
            that.show_type = e;
            that.show_shardow = true;
        },
        close() {
            let that = this;
            that.show_shardow = false;
            that.show_delete = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleCurrentChange(val) {
            let that = this;
            that.pageNumber = val;
            that.ajaxload();
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../userManagement/userManagement.css");


.show_detail {
    height: 344rem;
}

.shardow_title {
    width: 120rem;
}

.sons_img {
    width: 100%;
    height: 100%;
}

.img62 {
    width: 18rem;
    height: 14rem;
}

.img_banner {
    width: 40rem;
    height: 30rem;
}

.img_level {
    width: 80rem;
    height: 20rem;
}

>>>.el-button {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/PersonnelManagement/PersonnelManagement.vue